import { useNavigate } from "react-router-dom";
import { useMarketingTracking } from "../../marketing.analytics";
import { MarketingAudienceCtas, type Props as CtasProps } from "./MarketingAudienceCtas";
import type { AudienceCta } from "./marketingAudienceCtas.data";

export type Props = Omit<CtasProps, "onCtaClick">;

/**
 * Container for MarketingAudienceCtas.
 *
 * Records the click before navigating, with the slug of the form it leads to.
 * That slug is the whole reason the funnel can tell a funder clicking through
 * from a participant doing the same.
 */
export function MarketingAudienceCtasContainer(props: Props) {
  const navigate = useNavigate();
  const { trackCtaClick } = useMarketingTracking();

  const handleCtaClick = (cta: AudienceCta) => {
    trackCtaClick(cta.label, cta.formSlug ? { form_slug: cta.formSlug } : {});
    navigate(cta.href);
  };

  return <MarketingAudienceCtas {...props} onCtaClick={handleCtaClick} />;
}

export default MarketingAudienceCtasContainer;
